import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

import auth from './modules/auth'
import quote from './modules/quote'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tasks: []
  },
  getters: {
    tasks: state => state.tasks,
    loading: state => state.tasks.length > 0,
    loadingProgress: state => {
      let progressTaskLen = 0
      let totalProgress = 0

      state.tasks
        .filter(task => {
          if (!_.isNull(task.progress)) {
            progressTaskLen++
            return true
          }

          return false
        })
        .map(task => {
          totalProgress = totalProgress + task.progress / progressTaskLen
        })

      return totalProgress
    }
  },
  mutations: {
    insertTask: (state, id) => {
      state.tasks.push({
        id,
        progress: null
      })
    },
    removeTask: (state, index) => {
      state.tasks.splice(index, 1)
    },
    updateTaskProgress: (state, { index, progress }) => {
      Vue.set(state.tasks[index], 'progress', progress)
    },
    clearTasks: state => (state.tasks = [])
  },
  actions: {
    startTask ({ commit }, { id }) { commit('insertTask', id) },
    endTask ({ commit, getters }, { id }) {
      const index = _.findIndex(getters.tasks, t => t.id === id)
      commit('removeTask', index)
    },
    clearTasks ({ commit }) { commit('clearTasks') },
    updateTaskProgress ({ commit, getters }, { id, progress }) {
      const index = _.findIndex(getters.tasks, t => t.id === id)
      commit('updateTaskProgress', { index, progress })
    }
  },
  modules: { auth, quote }
})
